// extracted by mini-css-extract-plugin
export default {"Splash":"Splash_Splash__O1Yhk","Message":"Splash_Message__5KN+i","Panel":"Splash_Panel__27Sxu"};